import React from 'react';
import { BodyText, DataGrid, IFilteredDataGridColumnProps } from 'ui-toolkit';
import { IRoleData } from '../../../types/administration/userAdministration/IRole';

export interface IRolesTableProps {
  data: IRoleData[];
  isFetching: boolean;
}

const columns: IFilteredDataGridColumnProps<IRoleData>[] = [
  {
    dataField: 'label',
    headerStyle: { width: '120px' },
    text: 'Role Name',
  },
  {
    dataField: 'description',
    headerStyle: { width: '150px' },
    text: 'Description',
  },
  {
    dataField: 'users',
    formatter: (column, row) => {
      if (Array.isArray(row.users) && row.users.length > 0) {
        return (
          <BodyText>
            <ul style={{ columns: '3' }}>
              {[...row.users]
                .sort((a, b) => (a.fullName > b.fullName ? 1 : -1))
                .map((user) => (
                  <li key={user.id}>{user.fullName}</li>
                ))}
            </ul>
          </BodyText>
        );
      }

      return <BodyText>No Users</BodyText>;
    },
    text: 'Users',
  },
];

export const RolesTable: React.FC<IRolesTableProps> = ({ data, isFetching }) => {
  return <DataGrid columns={columns} data={data} keyField="id" loading={isFetching} remote />;
};
